// extracted by mini-css-extract-plugin
module.exports = {"content":"content-2SzEb"};